import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '../utils/api';

/**
 * AdminSetup Component - SECURITY NOTE
 * 
 * This component is for DEVELOPMENT/INITIAL SETUP ONLY.
 * In production, admin credentials should be configured via:
 * 1. Environment variables (ADMIN_EMAIL, ADMIN_PASSWORD)
 * 2. Netlify dashboard settings
 * 
 * IMPORTANT: After initial setup, change the password immediately
 * through the admin panel settings page.
 */
export function AdminSetup() {
  const [setupComplete, setSetupComplete] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkExistingAdmin();
  }, []);

  const checkExistingAdmin = async () => {
    try {
      // Check if admin can already log in (meaning setup is done)
      const response = await fetch(API_ENDPOINTS.login, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: 'admin',
          password: 'check_if_exists', // This will fail but tells us if admin exists
        }),
      });

      // If we get 401 with "Invalid credentials", admin exists
      // If we get another error, admin doesn't exist yet
      if (response.status === 401) {
        setMessage('Admin account is already configured. Please log in.');
        setSetupComplete(true);
      } else {
        setMessage('Please configure admin credentials in Netlify environment variables.');
      }
    } catch (error: any) {
      setMessage('Unable to verify admin status. Please check your configuration.');
    }
    setIsLoading(false);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: '#E8B8B0' }}
    >
      <div
        className="w-full max-w-md p-8 rounded-3xl shadow-lg text-center"
        style={{ backgroundColor: '#F0C2B5' }}
      >
        <h2 className="mb-4 text-xl font-semibold" style={{ color: '#444444' }}>
          Admin Setup
        </h2>
        
        {isLoading ? (
          <div style={{ color: '#444444' }}>Checking configuration...</div>
        ) : (
          <>
            <div
              className="p-4 rounded-lg mb-4"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', color: '#444444' }}
            >
              {message}
            </div>

            <div className="text-sm mt-4 p-4 rounded-lg" style={{ backgroundColor: 'rgba(255, 200, 200, 0.5)', color: '#444444' }}>
              <p className="font-bold mb-2">Security Setup Instructions:</p>
              <ol className="text-left list-decimal list-inside space-y-1">
                <li>Go to Netlify Dashboard → Site Settings</li>
                <li>Navigate to Environment Variables</li>
                <li>Set ADMIN_EMAIL and ADMIN_PASSWORD</li>
                <li>Set JWT_SECRET (use: openssl rand -hex 32)</li>
                <li>Redeploy your site</li>
              </ol>
            </div>

            {setupComplete && (
              <button
                onClick={() => window.location.reload()}
                className="mt-4 px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all"
                style={{ backgroundColor: '#F29B70', color: '#444444' }}
              >
                Continue to Login
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
